import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideAppInitializer } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { TranslateTitleStrategy } from './Modules/Shared/Strategies/translate-title.strategy';
import { routes } from './Modules/Navigation/routes';
import { provideHttpClient, withFetch, withInterceptors, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { httpLoaderFactory } from './Modules/Shared/Factories/http-loader.factory';
import { tokenInterceptor } from './Modules/Shared/Interceptors/token.interceptor';
import { loadingInterceptor } from './Modules/Shared/Interceptors/loading.interceptor';
import { errorInterceptor } from './Modules/Shared/Interceptors/error.interceptor';
import { initializeApp } from './Modules/Shared/Factories/initialize-app.factory';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { PieChart, BarChart, GaugeChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent, TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  PieChart,
  BarChart,
  GaugeChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  CanvasRenderer,
]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(initializeApp),

    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: TranslateTitleStrategy },
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor, loadingInterceptor, errorInterceptor])
    ),
    provideEchartsCore({ echarts }),

    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ]),

  ]
};